import { __assign } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getImageStylesAndSrc } from './helpers';
import ImgZoomable from './ImageZoomable';
import Img from './ImageBase';
import { MatureContext } from '../../../../Context';
import HiddenDumbView from '../../../../DeviationViews/Dumbo/Hidden';
import isNumber from 'lodash/isNumber';
var ImageView = function (props) {
    var deviation = props.deviation, propsWidth = props.width, config = props.config;
    var showMatureContent = useContext(MatureContext);
    if ((!showMatureContent && deviation.isMature) ||
        deviation.isBlocked ||
        deviation.isAntisocial) {
        return (React.createElement(HiddenDumbView, __assign({}, props, { width: isNumber(propsWidth) ? propsWidth : 780 })));
    }
    var calculatedProps = getImageStylesAndSrc(deviation, propsWidth, config);
    if (!calculatedProps) {
        return null;
    }
    var allowFullview = calculatedProps.allowFullview, canBeLinked = calculatedProps.canBeLinked, wrapperStyles = calculatedProps.wrapperStyles, coverThumb = calculatedProps.coverThumb, imgStyles = calculatedProps.imgStyles;
    var ImageComponent = allowFullview && !canBeLinked ? ImgZoomable : Img;
    return (React.createElement("div", { className: classnames(getThumbGlobalClassNames(deviation)), style: wrapperStyles },
        React.createElement(EditorDeviationLink, { link: config.link, deviation: deviation, linkClass: "gallery-link" },
            React.createElement(ImageComponent, { file: coverThumb, deviation: deviation, imgStyles: imgStyles, width: propsWidth }))));
};
ImageView.displayName = 'ImageView';
export default ImageView;
//# sourceMappingURL=Image.js.map